import React from 'react';
import { Button, Popconfirm, Tag } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';

const ItemCard = ({ 
  item, 
  onEdit, 
  onDelete, 
  renderImage, 
  renderTitle, 
  renderContent, 
  renderMeta,
  showLink = true 
}) => {  return (
    <div className="item-card">
      <div className="card-header">
        <div className="card-actions">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(item)}
            size="small"
          />
          <Popconfirm
            title="Tem certeza que deseja deletar este item?"
            onConfirm={() => onDelete(item._id)}
            okText="Sim"
            cancelText="Não"
          >
            <Button type="text" danger icon={<DeleteOutlined />} size="small" />
          </Popconfirm>
        </div>
      </div>

      {renderImage && (
        <div className="card-image-container">
          {renderImage(item)}
        </div>
      )}

      <h3 className="card-title">
        {renderTitle ? renderTitle(item) : item.titulo || item.nome || item.pergunta}
      </h3>

      <div className="card-content">
        {renderContent && renderContent(item)}
      </div>

      <div className="card-meta">
        {renderMeta && renderMeta(item)}
        
        {item.createdAt && (
          <span className="card-date">
            {new Date(item.createdAt).toLocaleDateString('pt-BR')}
          </span>
        )}

        {showLink && item.link && (
          <a 
            href={item.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="card-link"
          >
            <EyeOutlined /> Ver mais
          </a>
        )}
      </div>
    </div>
  );
};

export default ItemCard;
